import { whoOf } from './_shared';

/**
 * **攻撃宣言**（Issue #589）。`direct` ＝ 直接攻撃（対象なし）/ `monster` ＝ モンスターに攻撃
 * （対象が裏側かは `target.faceUp`）。事実: `attacker` / `target` を盤面の今の姿で（表裏・ATK / DEF・レベル・元々の値）。
 * 攻撃するカードの `uid` / `zone` / `player` を payload の先頭にも写す
 */
export const VARIANTS = Object.freeze([
  { name: 'direct', label: '直接攻撃' },
  { name: 'monster', label: 'モンスターに攻撃' },
]);

export const attackSituation = ({ payload, board }) => (payload?.attacker?.uid ? {
  ...payload,
  variant: payload.target?.uid ? 'monster' : 'direct',
  uid: payload.attacker.uid,
  zone: payload.attacker.zone,
  player: payload.attacker.player,
  attacker: whoOf(payload.attacker, board),
  target: payload.target?.uid ? whoOf(payload.target, board) : null,
} : null);

export default Object.freeze({ event: 'attack', variants: VARIANTS, classify: attackSituation });
